import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AsistenteVentanaComponent } from './asistente-ventana.component';
import { AsistenciaChatModule } from '../asistencia-chat/asistencia-chat.module';
import { AsistenciaMailModule } from '../asistencia-mail/asistencia-mail.module';
import { AsistenciaMenuArbolModule } from '../asistencia-menu-arbol/asistencia-menu-arbol.module';

@NgModule({
  imports: [
    CommonModule,
    AsistenciaChatModule,
    AsistenciaMailModule,
    AsistenciaMenuArbolModule
  ],
  declarations: [
    AsistenteVentanaComponent
  ],
  exports: [
    AsistenteVentanaComponent
 ],
 bootstrap: [
  AsistenteVentanaComponent
]
})
export class AsistenteVentanaModule { }
